(function () {
  function gal() {
    document.querySelectorAll('[data-csl-gal]').forEach(function (g) {
      if (g.dataset.bound) return; g.dataset.bound = '1';
      var track = g.querySelector('.csl-gal__track'), thumbs = g.querySelector('.csl-gal__thumbs');
      var slides = Array.prototype.slice.call(track.children);
      slides.forEach(function (s, i) {
        var im = s.querySelector('img'); if (!im) return;
        var b = document.createElement('button'); b.type = 'button'; b.className = 'csl-gal__t'; b.setAttribute('aria-label', 'Imagen ' + (i + 1));
        var c = document.createElement('img'); c.src = (im.currentSrc || im.src).replace(/width=\d+/, 'width=120'); c.width = 52; c.height = 52; c.loading = 'lazy'; c.alt = ''; b.appendChild(c);
        b.addEventListener('click', function () { track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
        thumbs.appendChild(b);
      });
      function upd() { var i = Math.round(track.scrollLeft / track.clientWidth); Array.prototype.forEach.call(thumbs.children, function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); }); }
      track.addEventListener('scroll', upd, { passive: true }); upd();
    });
  }
  function galLazy() {
    document.querySelectorAll('[data-csl-gal]').forEach(function (g) {
      if (g.dataset.lazyBound) return; g.dataset.lazyBound = '1';
      var track = g.querySelector('.csl-gal__track'), all = false;
      var imgs = Array.prototype.slice.call(g.querySelectorAll('img[data-csl-srcset]'));
      function one(im) {
        if (!im.getAttribute('data-csl-srcset')) return;
        im.sizes = '100vw'; im.srcset = im.getAttribute('data-csl-srcset'); im.src = im.getAttribute('data-csl-src');
        im.removeAttribute('data-csl-srcset');
      }
      function everything() { all = true; imgs.forEach(one); }
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { g.addEventListener(ev, everything, { once: true, passive: true }); });
      if (track) track.addEventListener('scroll', everything, { once: true, passive: true });
      // Paliers : dès que la 1re photo est affichée -> photos 2-3 tout de suite, 4-5 après 1 s, 6 et suivantes après 2 s
      function start() {
        imgs.forEach(function (im, i) {
          var d = i < 2 ? 0 : (i < 4 ? 1000 : 2000);
          setTimeout(function () { if (!all) one(im); }, d);
        });
      }
      var first = g.querySelector('.csl-gal__s img:not([data-csl-srcset])');
      if (!first || first.complete) start(); else first.addEventListener('load', start, { once: true });
    });
  }
  function size() {
    document.querySelectorAll('[data-csl-size]').forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = '1';
      b.addEventListener('click', function () { var d = document.getElementById(b.getAttribute('data-csl-size')); if (d && d.showModal) d.showModal(); });
    });
    document.addEventListener('click', function (e) { if (e.target.matches && e.target.matches('.csl-sizedlg')) e.target.close(); });
  }
  function sticky() {
    var bar = document.querySelector('[data-csl-sticky]'), bundle = document.querySelector('cira-bundle');
    if (!bar || !bundle) return;
    if (bar.dataset.cslStkBound) return; bar.dataset.cslStkBound = '1';
    var btn = bar.querySelector('.csl-stk__b'), idle = btn.textContent, touched = false;
    function cartBtn() { return bundle.querySelector('.cirab__btn'); }
    function visible(el) { var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; }
    function label() {
      if (!touched) { btn.textContent = idle; btn.removeAttribute('data-csl-add'); btn.setAttribute('href', '#cira-oferta'); return; }
      var pr = bundle.querySelector('.cirab__card.is-on .cirab__prices strong');
      btn.textContent = 'Agregar al carrito' + (pr ? ' · ' + pr.textContent.trim() : '');
      btn.setAttribute('data-csl-add', '1');
    }
    function update() {
      var b = bundle.getBoundingClientRect(), c = cartBtn();
      var cartInView = c && visible(c);
      bar.classList.toggle('is-on', !cartInView);
      label();
    }
    document.addEventListener('change', function (e) {
      if (e.isTrusted && e.target && e.target.tagName === 'SELECT' && e.target.closest('cira-bundle')) { touched = true; update(); }
    }, true);
    new MutationObserver(function () { label(); }).observe(bundle, { childList: true, subtree: true });
    window.addEventListener('scroll', update, { passive: true }); document.addEventListener('scroll', update, { passive: true, capture: true }); window.addEventListener('resize', update); update();
  }
  function scroller(el) {
    for (var p = el.parentElement; p && p !== document.body && p !== document.documentElement; p = p.parentElement) {
      var o = getComputedStyle(p).overflowY;
      if ((o === 'auto' || o === 'scroll') && p.scrollHeight > p.clientHeight + 1) return p;
    }
    return null;
  }
  function anchors() {
    if (document.documentElement.dataset.cslAnch) return; document.documentElement.dataset.cslAnch = '1';
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#cira-oferta"]'); if (!a) return;
      if (a.getAttribute('data-csl-add') === '1') { var cb = document.querySelector('cira-bundle .cirab__btn'); if (cb && !cb.disabled) { e.preventDefault(); e.stopPropagation(); cb.click(); return; } }
      var t = document.getElementById('cira-oferta'); if (!t) return;
      e.preventDefault(); e.stopPropagation();
      /* sur ordinateur le thème fait défiler .page-wrapper (html/body en overflow:hidden) : window.scrollTo ne fait rien */
      var sc = scroller(t);
      if (sc) { var yy = t.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - 70; sc.scrollTo({ top: Math.max(yy, 0), behavior: 'smooth' }); }
      else { var y = t.getBoundingClientRect().top + window.pageYOffset - 70; window.scrollTo({ top: y, behavior: 'smooth' }); }
    }, true);
  }
  function vids() {
    if (document.documentElement.dataset.cslVidBound) return; document.documentElement.dataset.cslVidBound = '1';
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-csl-vid]'); if (!t || t.getAttribute('data-mode') === 'auto') return;
      var kind = t.getAttribute('data-kind'); if (kind === 'empty') return;
      var all = document.querySelectorAll('[data-csl-vid]');
      Array.prototype.forEach.call(all, function (o) {
        if (o === t) return; var ov = o.querySelector('video'); if (ov) { ov.pause(); } o.classList.remove('is-playing');
        var fr = o.querySelector('iframe'); if (fr) { fr.remove(); }
      });
      if (kind === 'embed') {
        if (t.querySelector('iframe')) return;
        var src = t.querySelector('[data-embed]').getAttribute('data-embed');
        var f = document.createElement('iframe'); f.src = src; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true; f.title = 'Video';
        t.querySelector('.csl-vid__box').appendChild(f); t.classList.add('is-playing'); return;
      }
      var v = t.querySelector('video'); if (!v) return; ensureSrc(v);
      if (v.paused) { v.muted = false; var pr = v.play(); if (pr && pr.catch) pr.catch(function () { v.muted = true; v.play(); }); t.classList.add('is-playing'); }
      else { v.pause(); t.classList.remove('is-playing'); }
    });
  }
  function ensureSrc(v) {
    if (v && v.dataset.src && !v.getAttribute('src')) { v.src = v.dataset.src; v.load(); }
  }
  function autovids() {
    var els = document.querySelectorAll('[data-csl-vid][data-mode="auto"]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        var t = e.target, v = t.querySelector('video');
        if (v) { if (e.isIntersecting) { ensureSrc(v); v.muted = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { v.pause(); } return; }
        var h = t.querySelector('[data-embed]');
        if (h && e.isIntersecting && !t.querySelector('iframe')) {
          var f = document.createElement('iframe'); f.src = h.getAttribute('data-embed'); f.allow = 'autoplay; encrypted-media'; f.title = 'Video'; t.querySelector('.csl-vid__box').appendChild(f);
        }
      });
    }, { threshold: 0.25 });
    var near = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { var v = e.target.querySelector('video'); if (v) { ensureSrc(v); v.preload = 'auto'; } near.unobserve(e.target); } });
    }, { rootMargin: '500px 0px' });
    Array.prototype.forEach.call(els, function (el) { if (!el.dataset.cslAuto) { el.dataset.cslAuto = '1'; io.observe(el); near.observe(el); } });
  }
  function run() { gal(); galLazy(); size(); sticky(); anchors(); vids(); autovids(); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();
(function () {
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmt(d) { try { return new Date(d + 'T00:00:00').toLocaleDateString('es-MX', { year: 'numeric', month: 'short', day: 'numeric' }); } catch (e) { return d; } }
  function init(sec) {
    if (sec.dataset.cslOpBound) return; sec.dataset.cslOpBound = '1';
    fetch(sec.dataset.url).then(function (r) { return r.json(); }).then(function (all) {
      var list = all[sec.dataset.handle] || [];
      if (!list.length) { sec.style.display = 'none'; return; }
      var avg = list.reduce(function (a, x) { return a + x.r; }, 0) / list.length;
      var sum = sec.querySelector('.csl-op__sum'); sum.hidden = false;
      sum.querySelector('.csl-op__avg').textContent = avg.toFixed(1).replace('.', ',');
      sum.querySelector('.csl-op__cnt').textContent = list.length + ' opiniones';
      var box = sec.querySelector('.csl-op__list'), more = sec.querySelector('.csl-op__more'), shown = 0, step = 6;
      function render() {
        list.slice(shown, shown + step).forEach(function (x) {
          var c = document.createElement('article'); c.className = 'csl-op__c';
          c.innerHTML = '<div class="csl-op__top"><span class="csl-op__n">' + esc(x.n) + '</span><span class="csl-op__d">' + esc(fmt(x.d)) + '</span></div><div class="csl-op__st" aria-label="' + x.r + ' de 5">' + '★'.repeat(x.r) + '<span style="opacity:.25">' + '★'.repeat(5 - x.r) + '</span></div>' + (x.t ? '<p class="csl-op__tt">' + esc(x.t) + '</p>' : '') + '<p class="csl-op__b">' + esc(x.b) + '</p>' + (x.p ? '<p class="csl-op__p">' + esc(x.p) + '</p>' : '');
          box.appendChild(c);
        });
        shown += step; more.hidden = shown >= list.length;
      }
      more.addEventListener('click', render); render();
    }).catch(function () { sec.style.display = 'none'; });
  }
  function run() { document.querySelectorAll('[data-csl-reviews]').forEach(init); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();
